import React from 'react'
import WidgetIcon from '../../../Atoms/WidgetIcon/WidgetIcon'
import { ReactComponent as Icon } from './SqlTableWidget.Icon.svg'

const SqlTableWidgetIcon = () => <WidgetIcon icon={Icon} />

export default SqlTableWidgetIcon
